import { render, staticRenderFns } from "./WildHeartsGameTile.vue?vue&type=template&id=077aa30a&lang=pug&"
import script from "./WildHeartsGameTile.vue?vue&type=script&lang=js&"
export * from "./WildHeartsGameTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports